import React from "react";
import {InventoryOutlined} from "@mui/icons-material";
import Applet from "../../Applet";
import ChangeOrderMemberTable from "../../../../components/Foundation/ChangeOrderMemberTable";
import {hasPrivilege} from "../../../../util/SessionContext";
import {CHANGE_ORDER, allowedMenuOptions} from "../../../../util/changeOrderPrivileges";

// The records inside one change order, queried by ChangeOrderUSID.
//
// IT SHOWS BOTH THE SNAPSHOT AND THE LIVE VALUE. "Revision" is what the record was when it joined;
// "Now" is what it is today. They differ when somebody has revised a member since it was put in the
// package -- which is exactly what a reviewer needs to see before signing, and what the change
// order's content hash will already have marked the signatures stale for.
class ChangeOrderMemberTableApplet extends Applet {

    render() {
        return <ChangeOrderMemberTable applet={this}
                                       pageSize={this.props.PageSize ?? this.state.PageSize}
                                       placement={this.state.Placement}
                                       columns={this.state.Columns}
                                       title="Records in this change order"
                                       icon={<InventoryOutlined/>}
                                       enterpriseComponent={this.getEnterpriseComponent()}
                                       sort={this.state.Sort}
                                       menu={this.state.Menu}
                                       rowHeight={this.state.RowHeight}
                                       enableSearch={false}
                                       enableSort={true}
        />;
    }

    state = {
        Name: "ChangeOrderMemberTableApplet",
        // ADD SITS IN THE GRID'S OWN MENU, not on the page: the action belongs to the thing it
        // changes. It is refused server-side once the change order leaves DRAFT, and the page hides
        // it there too rather than offering a door that answers 409.
        Menu: {options: allowedMenuOptions([
            {displayValue: "Add record", value: "Add Change Order Member"},
            {displayValue: "Refresh", value: "Refresh"},
        ], {"Add Change Order Member": CHANGE_ORDER.ADD_RECORD}, hasPrivilege)},
        RowHeight: 48,
        PageSize: {"default": 50, "xs": 5, "sm": 5, "md": 50, "lg": 50, "lx": 50},
        // Array, not a map -- see ChangeOrderTableApplet for what the map shape costs.
        Sort: [{
            "Identifier": "Record",
            "Visible": true,
            "Default": true,
            "Options": [{"Direction": "ASC", "SortAttribute": "RecordObjectID", "DisplayName": "Record"}],
        }],
        Placement: {
            "xl": [
                {id: "Actions"},
                {id: "RecordObjectID"},
                {id: "RecordName"},
                {id: "ObjectTypeName"},
                {id: "CurrentStatus"},
            ],
        },
        Columns: [
            {id: "Actions", width: 60, cellRenderer: "Action Cell", header: "disabled", headerRenderer: "Standard Single Header", headerTitle: "", hideable: false},
            {id: "RecordObjectID", width: 190, cellRenderer: "Member Id Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Record", hideable: false},
            {id: "RecordName", width: 320, cellRenderer: "Member Name Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Name", hideable: false},
            {id: "ObjectTypeName", width: 200, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Type", hideable: true},
            {id: "CurrentStatus", width: 150, cellRenderer: "Member Status Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Status", hideable: false},
        ],
    };
}

export default ChangeOrderMemberTableApplet;
